module.exports = __webpack_public_path__ + "media/images/BGNS-5b5e28f9.png";